/**
 * @desc 查看参数列表中的分厂列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamFactoryResponse>>> {
  return defHttp.get({
    url: '/web/ParamManage/getFactory',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamFactoryResponse>>> {
  return defHttp.get({
    url: '/mock/web/ParamManage/getFactory',

    params,
  });
}
